import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { WhatsAppService } from '../../../services/whats-app/whats-app.service';
import { InfoCategory } from '../../models/app/info-category';
import User from '../../models/user/user';

@Component({
  selector: 'app-menu-mobile',
  standalone: true,
  imports: [NgIf, NgFor, NgClass],
  templateUrl: './menu-mobile.component.html',
  styleUrls: ['./menu-mobile.component.scss'],
})
export class MenuMobileComponent {
  @Input() categories: InfoCategory[] = [];

  public menuOpen = false;
  public attOpen = false;
  public submenu: Record<string, boolean> = {};
  public user: User | undefined = new User();

  constructor(
    private router: Router,
    private authService: AuthService,
    private whatsAppService: WhatsAppService
  ) {
    this.authService.userData$.subscribe((res: any) => {
      this.user = undefined;
      if (res) {
        this.user = new User();
        this.user.fromJson(res);
      }
    });
  }

  toggleMenu() {
    this.submenu = {};
    this.menuOpen = !this.menuOpen;
    document.body.classList.toggle('no-scroll', this.menuOpen);
  }

  safeId(v?: string) {
    return v || '';
  }

  toSlug(v?: string) {
    return (v || '').replaceAll('_', '-').toLowerCase();
  }

  toggleAtt() {
    this.attOpen = !this.attOpen;

    if (this.attOpen) {
      Object.keys(this.submenu).forEach((key) => {
        this.submenu[key] = false;
      });
    }
  }

  toggleSub(id: string) {
    this.submenu[id] = !this.submenu[id];

    if (this.submenu[id]) {
      this.attOpen = false;
    }
  }

  go(path: string) {
    this.menuOpen = false;
    document.body.classList.remove('no-scroll');
    this.router.navigateByUrl(path);
  }

  onClickWhatsApp() {
    this.toggleMenu();
    this.whatsAppService.setOpenWhatsApp(true);
  }
}
